import { render } from "./BreedDetail.vue?vue&type=template&id=da28112a"
import script from "./BreedDetail.vue?vue&type=script&lang=js"
export * from "./BreedDetail.vue?vue&type=script&lang=js"

import "./BreedDetail.vue?vue&type=style&index=0&id=da28112a&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__